/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Mode_Dual_KeyInputs */

const en_timing_sync_mode_dual_key = /** @type {(inputs: Timing_Sync_Mode_Dual_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dual Key`)
};

const fr_timing_sync_mode_dual_key = /** @type {(inputs: Timing_Sync_Mode_Dual_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double touche`)
};

const de_timing_sync_mode_dual_key = /** @type {(inputs: Timing_Sync_Mode_Dual_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dual-Key`)
};

const it_timing_sync_mode_dual_key = /** @type {(inputs: Timing_Sync_Mode_Dual_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppia chiave`)
};

const ru_timing_sync_mode_dual_key = /** @type {(inputs: Timing_Sync_Mode_Dual_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Двойной ключ`)
};

const es_timing_sync_mode_dual_key = /** @type {(inputs: Timing_Sync_Mode_Dual_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doble llave`)
};

const zh_cn2_timing_sync_mode_dual_key = /** @type {(inputs: Timing_Sync_Mode_Dual_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`双钥匙`)
};

const ja_timing_sync_mode_dual_key = /** @type {(inputs: Timing_Sync_Mode_Dual_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デュアルキー`)
};

const hi_timing_sync_mode_dual_key = /** @type {(inputs: Timing_Sync_Mode_Dual_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डुअल की`)
};

const pt_pt2_timing_sync_mode_dual_key = /** @type {(inputs: Timing_Sync_Mode_Dual_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave dupla`)
};

/**
* | output |
* | --- |
* | "Dual Key" |
*
* @param {Timing_Sync_Mode_Dual_KeyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_mode_dual_key = /** @type {((inputs?: Timing_Sync_Mode_Dual_KeyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Mode_Dual_KeyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_mode_dual_key(inputs)
	if (locale === "de") return de_timing_sync_mode_dual_key(inputs)
	if (locale === "it") return it_timing_sync_mode_dual_key(inputs)
	if (locale === "ru") return ru_timing_sync_mode_dual_key(inputs)
	if (locale === "es") return es_timing_sync_mode_dual_key(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_mode_dual_key(inputs)
	if (locale === "ja") return ja_timing_sync_mode_dual_key(inputs)
	if (locale === "hi") return hi_timing_sync_mode_dual_key(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_mode_dual_key(inputs)
	return en_timing_sync_mode_dual_key(inputs)
});